import { datadogRum } from '@datadog/browser-rum';
import { resolveError } from '@jucy-nakuru/common/lib/errorHandler';
import { asError } from './asError';

export type LogLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export interface Breadcrumb {
    type?: string;
    level?: LogLevel;
    event_id?: string;
    category?: string;
    message?: string;
    data?: {
        [key: string]: unknown;
    };
    timestamp?: number;
}

interface SessionUser {
    id?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    [key: string]: unknown;
}
const breadCrumbs: Breadcrumb[] = [];

export default class ErrorReporter {
    static reportError({
        error: passedError,
        level = 'error',
        tags,
        extraInfo,
    }: {
        error: Error;
        level?: LogLevel;
        tags?: Record<string, string>;
        extraInfo?: Record<string, unknown>;
    }) {
        try {
            resolveError(passedError).then((resolvedError) => {
                datadogRum.addError(resolvedError, {
                    level,
                    tags,
                    extraInfo,
                    breadCrumbs,
                });
            });
        } catch (err) {
            datadogRum.addError(err, {
                passedError,
                level,
                tags,
                extraInfo,
                breadCrumbs,
            });
        }
    }

    static captureError(err: unknown) {
        datadogRum.addError(asError(err), { breadCrumbs });
    }

    static addBreadcrumb(breadcrumb: Breadcrumb) {
        breadCrumbs.push(breadcrumb);
    }

    static captureMessage(message: string, context: { level: LogLevel; extra: Record<string, unknown>; tags?: Record<string, string> }) {
        datadogRum.addAction(message, context);
    }

    static setTag(key: string, value?: string | number | boolean) {
        return datadogRum.setGlobalContextProperty(key, value);
    }

    static setUser(user: SessionUser) {
        return datadogRum.setUser(user);
    }
}
